import {
  Alignment,
  Button,
  Classes,
  Collapse,
  HTMLTable,
  Switch,
} from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import classNames from 'classnames';
import * as React from 'react';

import {
  PROJECT_DIAGRAM_ENTITY_DRAWER_SENSITIVE_PROPERTY_GROUP,
  TEST_IDS,
  getProjectDiagramEntityDrawerTableRowTestId,
} from 'src/constants/testIds';
import { SPGRow } from 'src/containers/PublishProjectDrawer/ModelConfigSPGRow';
import { SensitivePropertyGroupsInfo } from 'src/containers/PublishProjectDrawer/types';
import * as copy from 'src/templates/copy';

type ModelConfigSPGProps = {
  databaseId: string;
  sensitivePropertyGroups: SensitivePropertyGroupsInfo;
  handleUpdateSPG: (spg: SensitivePropertyGroupsInfo) => void;
  isPublishingSPG: boolean;
  setIsPublishingSPG: (isPublishingSPG: boolean) => void;
};

export const ModelConfigSPG: React.VFC<ModelConfigSPGProps> = ({
  databaseId,
  sensitivePropertyGroups,
  handleUpdateSPG,
  isPublishingSPG,
  setIsPublishingSPG,
}) => {
  const [isOpen, setIsOpen] = React.useState(isPublishingSPG);

  const handleTogglePublishing = () => {
    setIsOpen(!isPublishingSPG);
    setIsPublishingSPG(!isPublishingSPG);
  };

  return (
    <div className="sd-project-diagram-sensitive-property-groups">
      <div className="sd-drawer-group-label">
        <Switch
          alignIndicator={Alignment.RIGHT}
          checked={isPublishingSPG}
          className="sd-label-switch"
          data-testid={
            TEST_IDS.publishProjectDrawer.model.sensitivePropertyGroups.toggle
          }
          inline
          label={
            copy.components.publishProjectDrawer.modelConfiguration
              .sensitivePropertyGroups.label
          }
          onChange={handleTogglePublishing}
        />

        {isPublishingSPG ? (
          <Button
            className={Classes.END}
            data-testid={
              TEST_IDS.publishProjectDrawer.model.sensitivePropertyGroups
                .collapseButton
            }
            icon={isOpen ? IconNames.CHEVRON_UP : IconNames.CHEVRON_DOWN}
            minimal
            onClick={() => setIsOpen(!isOpen)}
          />
        ) : null}
      </div>
      <Collapse isOpen={isOpen}>
        <HTMLTable
          className={classNames(
            'sd-project-diagram-sensitive-property-groups__table',
            Classes.COMPACT
          )}
        >
          <thead>
            <tr>
              <td>
                {
                  copy.components.publishProjectDrawer.modelConfiguration
                    .sensitivePropertyGroups.groupLabel
                }
              </td>
              <td>
                {
                  copy.components.publishProjectDrawer.modelConfiguration
                    .sensitivePropertyGroups.configureLabel
                }
              </td>
            </tr>
          </thead>
          <tbody>
            {Object.keys(sensitivePropertyGroups).map((spg: string) => (
              <SPGRow
                key={spg}
                databaseId={databaseId}
                handleUpdateSPG={handleUpdateSPG}
                sensitivePropertyGroup={sensitivePropertyGroups[spg]}
                sensitivePropertyGroups={sensitivePropertyGroups}
                testId={getProjectDiagramEntityDrawerTableRowTestId(
                  spg,
                  PROJECT_DIAGRAM_ENTITY_DRAWER_SENSITIVE_PROPERTY_GROUP
                )}
              />
            ))}
          </tbody>
        </HTMLTable>
      </Collapse>
    </div>
  );
};
